<template>
  <div class="add-service-maintenance">
    <div class="search">
      <div class="sub-title">
        增值服务维护
      </div>
      <div class="add-customer" @click="openAddService">
        <span class="add-rectangle"></span>
        <span>新增</span>
      </div>
    </div>
    <div class="table">
      <el-table :data="tableData" style="width: 100%">
        <el-table-column v-for="(item, index) in tableTitle" :key="index" :prop="item.prop" :label="item.label"
          :min-width="item.width">
          <template slot-scope="scope">
            <div v-if="item.prop === 'statusVal'" :class="`status${scope.row.status}`">{{ scope.row.statusVal }}</div>
            <div v-else>{{ scope.row[item.prop] }}</div>
          </template>
        </el-table-column>
        <el-table-column label="操作">
          <template slot-scope="scope">
            <el-button type="text" class="btn-text" @click="openModService(scope.row)">编辑</el-button>
            <el-button type="text" class="btn-text" @click="updateStatus(scope.row)">
              {{ scope.row.status?'禁用':'启用'}}
            </el-button>
          </template>
        </el-table-column>
      </el-table>
      <div class="pagination">
        <pagination-tpl :total="total" :currentPage="currentPage" :pageSize="pageSize"
          @queryChange="queryChange"></pagination-tpl>
      </div>
    </div>

    <!-- 新增/编辑 -->
    <el-drawer :title="drawerTitle" :visible.sync="drawer" :wrapperClosable="false" :before-close="handleCloseDrawer">
      <el-form ref="addServiceMaintenanceForm" :rules="addServiceMaintenanceFormRules" :model="addServiceMaintenanceForm">
        <el-form-item label="增值服务名称" prop="serviceName">
          <el-input v-model="addServiceMaintenanceForm.serviceName" placeholder="请输入"></el-input>
        </el-form-item>
        <el-form-item label="备注" prop="remark">
          <el-input type="textarea" v-model="addServiceMaintenanceForm.remark" placeholder="请输入"></el-input>
        </el-form-item>
      </el-form>
      <div class="drawer-footer">
        <el-button class="btn-gray" @click="handleCloseDrawer">取消</el-button>
        <el-button class="btn-blue" @click="submit('addServiceMaintenanceForm')">确定</el-button>
      </div>
    </el-drawer>
  </div>
</template>

<script>
import PaginationTpl from "components/base/PaginationTpl";
import AddServiceMaintenance from '@/models/system/add-service-maintenance.js'
import { formaTimeToMinute } from "common/js/util";
export default {
  data() {
    return {
      tableData: [],
      tableTitle: [
        {prop: 'createTime', label: '创建时间', width: ''},
        {prop: 'serviceName', label: '增值服务名称', width: ''},
        {prop: 'remark', label: '备注', width: ''},
        { prop: 'statusVal', label: '状态', width: ''},
      ],
      total: 0,
      currentPage: 1,
      pageSize: 20,
      drawer: false,
      drawerTitle: '新增',
      addServiceMaintenanceForm: {
        id: null,
        serviceName: "",
        remark: ""
      },
      addServiceMaintenanceFormRules: {
        serviceName: [{ required: true, message: "请输入增值服务名称", trigger: "blur" }],
      },
    };
  },
  components: {
    PaginationTpl
  },
  created() {
    this.initAddServiceList()
  },
  methods: {
    /** 
     * @description 获取增值服务列表
    */
    initAddServiceList() {
      let pageNo = this.currentPage;
      let data = {
        pageNo
      }
      AddServiceMaintenance.getAddServiceMaintenanceList(data).then(res => {
        if (res.success) {
          let tableData = [];
          this.pageSize = res.result.pageSize;
          this.total = res.result.totalNum;
          res.result.items.map(value => {
            let obj = {};
            obj.id = value.id;
            obj.createTime = value.createTime == 0 ? '' : formaTimeToMinute(value.createTime);
            obj.serviceName = value.serviceName;
            obj.remark = value.remark;
            obj.status = value.status
            obj.statusVal = value.status ? "已启用" :'已禁用'
            tableData.push(obj);
          });
          this.tableData = tableData;
        }
      });
    },

    /**
     * @description 开启新增增值服务
     */
    openAddService() {
      this.drawerTitle = '新增'
      this.drawer = true;
    },
    /**
     * @description 开启编辑增值服务
     */
    openModService(row) {
      this.drawerTitle = '编辑'
      this.addServiceMaintenanceForm.id = row.id
      this.addServiceMaintenanceForm.serviceName = row.serviceName
      this.addServiceMaintenanceForm.remark = row.remark
      this.drawer = true;
    },

    /**
     * @desc 启用/禁用增值服务
     */
    updateStatus(row) {
      if (row.status == 1) {
        this.$confirm("禁用后，该增值服务变更为禁用状态，请确认", "禁用", {
          confirmButtonText: "禁用",
          cancelButtonText: "取消",
          confirmButtonClass: 'btn-red',
          cancelButtonClass: 'btn-gray'
        }).then(() => {
          this.postUpdateStatus(row.id, 0)
        });
      } else {
        this.$confirm("启用后，该增值服务变更为启用状态，请确认", "启用", {
          confirmButtonText: "确定",
          cancelButtonText: "取消",
          confirmButtonClass: 'btn-blue',
          cancelButtonClass: 'btn-gray'
        }).then(() => {
          this.postUpdateStatus(row.id, 1)
        });
      }
    },
    /**
     * @desc 更新使用状态
     * @param {*} id 增值服务id
     * @param {*} status 增值服务状态
     */
    postUpdateStatus(id, status) {
      let data = {
        status: status
      };
      AddServiceMaintenance.postUpdateAddServiceMaintenanceStatus(id, data).then(res => {
        if (res.success) {
          this.initAddServiceList();
        }
      });
    },

    queryChange(data) {
      this.currentPage = data.currentPage;
      this.initAddServiceList();
    },

    handleCloseDrawer() {
      this.$refs['addServiceMaintenanceForm'].resetFields();
      this.addServiceMaintenanceForm.id = null
      this.addServiceMaintenanceForm.serviceName = ""
      this.addServiceMaintenanceForm.remark = ""
      this.drawer = false;
    },

    /** 
     * @description 新增/编辑增值服务
    */
    submit(formName) {
      this.$refs[formName].validate(valid => {
        if (valid) {
          let data = {};
          data.serviceName = this.addServiceMaintenanceForm.serviceName;
          data.remark = this.addServiceMaintenanceForm.remark;
          if (this.drawerTitle === '编辑') {
            let id = this.addServiceMaintenanceForm.id;
            AddServiceMaintenance.postModAddServiceMaintenance(id, data).then(res => {
              this.commonCententOfAddServiceOrModService(res)
            });
          } else {
            AddServiceMaintenance.postAddAddServiceMaintenance(data).then(res => {
              this.commonCententOfAddServiceOrModService(res)
            });
          }
        } else {
          console.log("error submit!!");
          return false;
        }
      });
    },

    commonCententOfAddServiceOrModService(res) {
      if (res.success) {
        this.handleCloseDrawer();
        this.initAddServiceList();
      } else {
        this.$message({
          type: 'error',
          message: res.message
        })
      }
    }
  }
};
</script>
<style lang="scss">
@import '@/assets/style/layout/system/add-service-maintenance.scss';
</style>

